const ORIGIN_CTA_URL_KEY = 'prepeers:origin-cta-url' as const

/**
 * Mémorise l'URL absolue de la page de provenance du CTA (avant l'entrée dans le tunnel).
 * @param {string} url - URL absolue de la page d'origine.
 * @returns {void}
 */
export function setOriginCtaUrlInLocalStorage(url: string): void {
  if (!import.meta.client) return
  localStorage.setItem(ORIGIN_CTA_URL_KEY, url)
}

/**
 * Lit l'URL d'origine du CTA mémorisée (rafraîchie à chaque nouvelle entrée dans le tunnel).
 * @returns {string | null} URL d'origine ou `null` si aucune.
 */
export function getOriginCtaUrlInLocalStorage(): string | null {
  if (!import.meta.client) return null
  return localStorage.getItem(ORIGIN_CTA_URL_KEY)
}
